import { AxiosError, AxiosResponse, default as axios } from 'axios';
import * as status from 'http-status-codes';
import { Consent, ConsentType, ConsentResponse, ConsentSpecification } from '../Model';
import { Auth } from '@trustpilot/ecommscript-integrationappauth';
import { logError } from './ecommscriptClient';
import { Tools } from '../Tools';

const api = `${process.env.REACT_APP_B2bApiUrl}/v1/private/consents`;
const consentSpecificationsUrl = `${process.env.REACT_APP_B2bApiUrl}/v1/private/consents-specifications`;

export const giveConsent = (consent: Consent): Promise<boolean> => {
    const headers = {
        'Authorization': `Bearer ${Auth.getAccessToken()}`,
        'Content-Type': 'application/json',
    };
    return axios
        .get(`${api}/units/${consent.unitId}`, { headers })
        .then((consentsResponse: AxiosResponse<Consent[]>) => {
            return consentsResponse.data.reduce((result: Consent, item: Consent) => {
                return (item.type === ConsentType.Ecomm) ? item : result;
            }, null);
        })
        .then((current: Consent) => {
            if (!current) {
                return axios
                    .post(`${api}`, consent, { headers })
                    .then((createResponse: AxiosResponse<Consent>) => {
                        if (createResponse.status === status.CREATED) {
                            return true;
                        } else {
                            throw new Error(`Failed to create consent. Reason: ${createResponse.data}`);
                        }
                    });
            } else {
                return axios
                    .put(`${api}/${current.id}`, consent, { headers })
                    .then((updateResponse: AxiosResponse<Consent>) => {
                        if (updateResponse.status === status.NO_CONTENT) {
                            return true;
                        } else {
                            throw new Error(`Failed to update consent. Reason: ${updateResponse.data}`);
                        }
                    });
            }
        }).catch((err: AxiosError) => {
            logError({
                message: `Failed on giveConsent with consent ${JSON.stringify(consent)} and request headers ${JSON.stringify(headers)}`,
                error: JSON.stringify(err)
            });
            Tools.resetTokenIfUnauthorized(err.response, consent.unitId);
            return false;
        });
};

export const getConsentSpecifications = async (type: string, locale: string):
    Promise<ConsentSpecification[]> => {
    const headers = {
        'Authorization': `Bearer ${Auth.getAccessToken()}`,
        'Content-Type': 'application/json',
    };

    return axios
        .get(`${consentSpecificationsUrl}?type=${type}&locale=${locale}`, { headers })
        .then((response: AxiosResponse<ConsentSpecification[]>) => {
            return response.data;
        })
        .catch((err: AxiosError) => {
            logError({
                message: `Failed on getConsentSpecifications with type ${type}, locale ${locale} and request headers ${JSON.stringify(headers)}`,
                error: JSON.stringify(err)
            });
            Tools.resetTokenIfUnauthorized(err.response);
            return [];
        });
};

export const consentIsAccepted = (key: string): Promise<ConsentResponse> => {
    const headers = {
        'Content-Type': 'application/json',
    };
    return axios
        .get(`${process.env.REACT_APP_SettingsApiUrl}/api/settings/${key}/consent`, { headers })
        .then((res: AxiosResponse<ConsentResponse>) => {
            return res.data;
        }).catch((err: AxiosError) => {
            logError({
                message: `Failed on consentIsAccepted with key ${key} and request headers ${JSON.stringify(headers)}`,
                error: JSON.stringify(err)
            });
            Tools.resetTokenIfUnauthorized(err.response);
            return {
                consentIsAccepted: false,
                businessUnitId: '',
            };
        });
};



// WEBPACK FOOTER //
// ./src/Api/businessConsentsClient.ts